import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../../elements/logo/Logo";
import MobileMenu from "./MobileMenu";
import { useTranslation } from "react-i18next";
import useStickyHeader from "./useStickyHeader";
import "./HeaderOne.css";

const HeaderOne = ({ btnStyle, HeaderSTyle }) => {
    const ref = useRef();
    const sticky = useStickyHeader(50);
    const headerClasses = `header-default ${sticky ? 'sticky' : ''}`;
    const { t, i18n } = useTranslation();
    const [mobileMenuShow, setMobileMenuShow] = useState(false);

    const handleToggleLang = (e) => {
        e.preventDefault();
        const cur = (i18n && i18n.language) ? i18n.language : 'en';
        const next = String(cur).toLowerCase().startsWith('en') ? 'zh' : 'en';
        i18n.changeLanguage(next);
    };

    const isEnUI = String((i18n && i18n.language) ? i18n.language : 'en').toLowerCase().startsWith('en');

    const handleMobileMenuToggle = () => {
        setMobileMenuShow(!mobileMenuShow);
    };

    const handleMobileMenuClose = () => {
        setMobileMenuShow(false);
    };

    return (
        <>
            <header ref={ref} className={`rn-header header-default ${HeaderSTyle} ${headerClasses}`}>
                <div className="container position-relative">
                    <div className="row align-items-center row--0">
                        <div className="col-lg-2 col-md-3 col-6">
                            <Logo
                                image={`${process.env.PUBLIC_URL}/images/logo/logo-cyberate.png`}
                                image2={`${process.env.PUBLIC_URL}/images/logo/logo-cyberate.png`}
                            />
                        </div>
                        <div className="col-lg-10 col-md-9 col-6">
                            <nav className="mainmenu-nav d-none d-lg-block">
                                <ul className="mainmenu d-flex align-items-center justify-content-between">
                                    <li><Link to="/">{t("1")}</Link></li>
                                    <li><Link to="/Service">{t("4")}</Link></li>
                                    <li><Link to="/AboutUs">{t("503")}</Link></li>
                                    <li><Link to="/contact">{t("6")}</Link></li>
                                    <li><Link className="header-free-btn" to="/FreeConsult"><span className="header-free-btn__inner">{t("dddi.nav.consult")}</span></Link></li>
                                    <li><a href="#lang" onClick={handleToggleLang}>{isEnUI ? 'EN/中文' : '中文/EN'}</a></li>
                                </ul>
                            </nav>
                            {/* Mobile Menu Button */}
                            <div className={`mobile-menu-btn d-lg-none ${mobileMenuShow ? 'hidden' : ''}`}>
                                <button 
                                    className={`mobile-menu-toggle ${mobileMenuShow ? 'active' : ''}`}
                                    onClick={handleMobileMenuToggle}
                                    aria-label="Toggle mobile menu"
                                >
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <MobileMenu show={mobileMenuShow} onClose={handleMobileMenuClose} />
        </>
    )
}
export default HeaderOne;